export default (fullAddress: string) => {
  if (fullAddress) {
    return `${fullAddress.substring(0, 5)}...${fullAddress.substring(
      fullAddress.length - 5,
      fullAddress.length
    )}`;
  } else {
    return "";
  }
};
